/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { xBaseTheme } from "@monsma/XDL/types";

const spaceBase = 15;
const spaceX = spaceBase;
const spaceY = spaceBase;

export default {
    size: "green",
    columns: 12,

    spaces: {
        none: {
            x: 0,
            y: 0,
        },
        xs: {
            x: spaceX * (1 / 3),
            y: spaceY * (1 / 3),
        },
        sm: {
            x: spaceX * (2 / 3),
            y: spaceY * (2 / 3),
        },
        md: {
            x: spaceX,
            y: spaceY,
        },
        lg: {
            x: spaceX * (4 / 3),
            y: spaceY * (4 / 3),
        },
        xl: {
            x: spaceX * (5 / 3),
            y: spaceY * (5 / 3),
        },
        xxl: {
            x: spaceX * 2,
            y: spaceY * 2,
        },
    },
} as xBaseTheme["helpers"];
